import React from "react";
import { connect } from "react-redux";

import { getData } from "Source/globalFunction";

import Select from "Components/common/Select/Select";

@connect(store => {
    return {
        loggedUser: store.loggedUser,
        files: store.files
    };
})

class Workstream extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchIsLoading: false,
            searched: []
        }
    }

    render() {
        const { dispatch, loggedUser, projectId, files } = this.props;

        const searchWorkstreams = value => {
            const url = "api/workstream";
            const params = {
                page: 1,
                projectId: projectId,
                userId: loggedUser.data.id,
                userRole: loggedUser.data.userRole 
            }

            this.setState({...this.state, searchIsLoading: true});

            getData(url, {params}, response => {
                if(response) {
                    this.setState({
                        ...this.state, 
                        searchIsLoading: false, 
                        searched: response.data.result.map(w => {
                            return {
                                value: w.id, 
                                label: w.workstream, 
                                others: {
                                    color: w.color
                                }
                            }
                        })
                    })
                }
            })
        }

        const handleOpenSelect = () => {
            searchWorkstreams();
        }

        const handleSearch = (value) => {
            searchWorkstreams(value);
        }

        const handleSelect = (value) => {
            dispatch({ type: "UPDATE_FILES_FILTERS", filters: {workstream: value} });
        }

        const handleClear = () => {
            dispatch({ type: "UPDATE_FILES_FILTERS", filters: {workstream: {}} });
        }
        
        return (
            <div class="optionRow workstreamOptionContainer">
                <span>Workstream</span>
                <div class="optionChoices searchIcon">
                    <Select 
                        showSelectedInOptions={false}
                        isSearchable={true}
                        isLoading={this.state.searchIsLoading}
                        classes={{options: "filesFilterOptions"}}
                        placeholder="Search"
                        options={this.state.searched}
                        selected={files.filters.options.workstream}
                        renderOption={option => (
                            <div class="workstreamOption">
                                <div class="workstreamColor" style={{backgroundColor: (option.others || {}).color}}></div>
                                <span>{option.label}</span>
                            </div>
                        )} 
                        renderSelected={option => (
                            <div class="workstreamOption">
                                <div class="workstreamColor" style={{backgroundColor: (option.others || {}).color}}></div>
                                <span>{option.label}</span>
                            </div>
                        )}
                        onOpen={handleOpenSelect}
                        onSearch={handleSearch}
                        onChange={handleSelect}
                        onClearSelected={handleClear}
                        isClose={files.filters.isCleared}
                    />
                </div>
            </div>
        );
    }
}

export default Workstream;